import React from "react";

/**
 * Loading state block. Uses the shared `.btn-spinner` animation.
 * @param {Object} props
 * @param {string} [props.title="Loading…"]
 * @param {React.ReactNode} [props.hint]
 */
export function LoadingState({ title = "Loading…", hint }) {
  return (
    <div className="ds-state" role="status" aria-live="polite">
      <div className="ds-state-icon"><span className="btn-spinner" aria-hidden /></div>
      <div className="ds-state-title">{title}</div>
      {hint && <div className="ds-state-hint">{hint}</div>}
    </div>
  );
}
